<sm-global-alerts></sm-global-alerts>
<sm-toast-list></sm-toast-list>
<router-outlet></router-outlet>
<!-- Global dialog container for entire app -->
<div kendoDialogContainer></div>